import { Observable } from 'rxjs';
import { ApiService } from './../api/api.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BroadcastService } from '../share/broadcast.service';

@Injectable({
  providedIn: 'root'
})
export class EventsCalendarService {

  constructor(private apiService: ApiService, private http: HttpClient) {}

  //LATITUDE getters, setters
  private _latitude: any;

  public get latitude(): any {
    return this._latitude;
  }

  public set latitude(value: any) {
    this._latitude = value;
  }

  //LONGITUDE getters, setters
  private _longitude: any;

  public get longitude(): any {
    return this._longitude;
  }

  public set longitude(value: any) {
    this._longitude = value;
  }

  createCalendarEvent(eventInfo): Observable<any> {
    return this.apiService.post('events/createEvent', eventInfo);
  }

  updateCalendarEvent(id, eventInfo): Observable<any> {
    return this.apiService.put(`events/updateEvent/${id}`, eventInfo);
  }

  deleteCalendarEvent(id): Observable<any> {
    return this.apiService.delete(`events/deleteEvent/${id}`);
  }

  getCalendarEvent(id): Observable<any> {
    return this.apiService.get(`events/getEvent/${id}`);
  }

  getAllEvents(): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.get(`events?lat=${this.latitude}&long=${this.longitude}`);
      else
        return this.http.get(environment.base_url + `events?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.get('events');
      else
        return this.http.get(environment.base_url + 'events');
    }

  }

  getMyEvents(): Observable<any> {
    if (this.isLocationStored()) {
      return this.apiService.get(`events/getUserEvents?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      return this.apiService.get('events/getUserEvents');
    }
  }

  getAccountTypeEvents(account_type_id): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.get(`events/getAccountTypeEvents/${account_type_id}?lat=${this.latitude}&long=${this.longitude}`);
      else
        return this.http.get(environment.base_url + `events/getAccountTypeEvents/${account_type_id}?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.get(`events/getAccountTypeEvents/${account_type_id}`);
      else
        return this.http.get(environment.base_url + `events/getAccountTypeEvents/${account_type_id}`);
    }

  }

  getEventsByDate(data): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.post(`events/eventsByDate?lat=${this.latitude}&long=${this.longitude}`, data);
      else
        return this.http.post(environment.base_url + `events/eventsByDate?lat=${this.latitude}&long=${this.longitude}`, data);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.post('events/eventsByDate', data);
      else
        return this.http.post(environment.base_url + 'events/eventsByDate', data);
    }
  }

  getAccountTypeDateEvents(data): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.post(`events/accountTypeDateEvents?lat=${this.latitude}&long=${this.longitude}`, data);
      else
        return this.http.post(environment.base_url + `events/accountTypeDateEvents?lat=${this.latitude}&long=${this.longitude}`, data);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.post('events/accountTypeDateEvents', data);
      else
        return this.http.post(environment.base_url + 'events/accountTypeDateEvents', data);
    }
  }

  getEventsByDateRange(data): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.post(`events/eventsByDateRange?lat=${this.latitude}&long=${this.longitude}`, data);
      else
        return this.http.post(environment.base_url + `events/eventsByDateRange?lat=${this.latitude}&long=${this.longitude}`, data);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.post('events/eventsByDateRange', data);
      else
        return this.http.post(environment.base_url + 'events/eventsByDateRange', data);
    }
  }

  getFilteredEvents(data): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.post(`events/event-filter?lat=${this.latitude}&long=${this.longitude}`, data);
      else
        return this.http.post(environment.base_url + `events/event-filter?lat=${this.latitude}&long=${this.longitude}`, data);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.post('events/event-filter', data);
      else
        return this.http.post(environment.base_url + 'events/event-filter', data);
    }
  }

  addToGoogleCalendar(data, db_event_id): Observable<any> {
    data.db_event_id = db_event_id;
    return this.http.post(environment.base_url + 'calendar-sync/add', data);
  }

  googleCalendarlisting(): Observable<any> {
    return this.http.get(environment.base_url + 'calendar-sync/listing');
  }

  isUserLoggedIn(){
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    }else{
      return false;
    }
  }

  isLocationStored() {
    const location_storage = JSON.parse(sessionStorage.getItem('location'));
    if (location_storage !== undefined && location_storage !== null) {
      this.latitude = location_storage.latitude;
      this.longitude = location_storage.longitude;
      return true;
    } else {
      return false;
    }
  }

}
